<!--
 * @Author:
 * @Description: 文档关联配置
-->
<template>
  <div class="h-full">
    <el-card class="h-full overflow-auto" :body-style="{ padding: '20px', height: '100%' }">
      <el-row>
        <el-input
          v-model="search.name"
          clearable
          class="w-200px ml-10px mr-10px"
          placeholder="任务名称"
          size="small"
        ></el-input>
        <selectStandardId @updateStandardId="updateStandardId" />
        <el-select
          v-model="search.classId"
          clearable
          filterable
          class="w-200px ml-10px mr-10px"
          placeholder="请选择实体"
          size="small"
        >
          <el-option
            v-for="item in classTypeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-button type="primary" @click="searchList">搜索</el-button>
        <el-button type="primary" :disabled="!$hasAccess('create')" @click="toAdd('create')"
          >新增</el-button
        >
        <el-button type="danger" :disabled="!$hasAccess('delete')" @click="toDelete(idList)"
          >删除</el-button
        >
        <!-- <el-button :disabled="!$hasAccess('export')">导出</el-button>
        <el-button :disabled="!$hasAccess('import')">导入</el-button> -->
      </el-row>
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        border
        class="mt-20px"
        height="calc(100% - 104px)"
        :highlight-current-row="true"
        @selection-change="selectionChange"
        @sort-change="sortChange"
        stripe
        ref="table"
        row-key="id"
      >
        <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
        <el-table-column type="index" label="序号" width="55"></el-table-column>
        <el-table-column prop="name" label="任务名称" show-overflow-tooltip></el-table-column>
        <el-table-column
          prop="documentTypeName"
          label="文档类型"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="standardName" label="标准库" show-overflow-tooltip></el-table-column>
        <el-table-column prop="className" label="解析实体" show-overflow-tooltip></el-table-column>
        <el-table-column
          prop="classAttributeName"
          label="解析属性"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="createdTime"
          label="创建时间"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="lastModifiedTime"
          label="修改时间"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" fixed="right" width="240">
          <template slot-scope="scope">
            <el-button size="mini" :loading="scope.row.loading" @click="toExecute(scope.row)"
              >手动执行</el-button
            >
            <el-button size="mini" @click="toAdd('update', scope.row)">编辑</el-button>
            <el-button size="mini" @click="toDelete([scope.row.id])">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="mt-20px float-right">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page.pageNo"
          :page-sizes="$pageSizeAll"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 新增/编辑弹框 -->
    <el-dialog
      :title="formTitle"
      :visible.sync="addVisiable"
      class="small-dialog"
      :close-on-click-modal="false"
      v-dialogDrag
      @close="closeBaseFormDialog"
    >
      <el-form ref="baseForm" label-width="150px" :model="form" :rules="rules">
        <el-form-item label="任务名称" prop="name">
          <el-input
            v-model="form.name"
            class="w-full"
            clearable
            placeholder="请输入任务名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="文档类型" prop="documentTypeId">
          <el-select
            v-model="form.documentTypeId"
            clearable
            filterable
            class="w-full"
            placeholder="请选择文档类型"
            size="small"
          >
            <el-option
              v-for="item in documentTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主题">
          <el-select
            v-model="form.subjectDomainId"
            clearable
            filterable
            class="w-full"
            placeholder="请选择主题"
            size="small"
            @change="changeThemeId"
          >
            <el-option
              v-for="item in themeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="解析实体" prop="classId">
          <el-select
            v-model="form.classId"
            clearable
            filterable
            class="w-full"
            placeholder="请选择实体"
            size="small"
            @change="changeClassId"
          >
            <el-option
              v-for="item in classList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="解析字段" prop="classAttributeId">
          <el-select
            v-model="form.classAttributeId"
            clearable
            filterable
            class="w-full"
            placeholder="请选择属性"
            size="small"
          >
            <el-option
              v-for="item in attributeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="closeBaseFormDialog">取消</el-button>
        <el-button type="primary" @click="saveForm">保存</el-button>
      </div>
    </el-dialog>

    <!-- 选择属性值 -->
    <selectAttributeValues
      :attributeValuesVisiable="attributeValuesVisiable"
      :classId="form.classId"
      :classAttributeId="form.classAttributeId"
      :attributeCode="attributeCode"
      @closeAttributeDialog="closeAttributeDialog"
      @updateAttributeValue="updateAttributeValue"
    />
  </div>
</template>

<script>
import assetService from '@/services/assetService'
import documentConfigService from '@/services/documentConfigService'
import StdSubjectDomainService from '@/services/bsApi/StdSubjectDomainService'
import StdClassTreeService from '@/services/bsApi/StdClassTreeService'
import stdClassListService from '@/services/stdClassListService'
import selectStandardId from '../../components/selectStandardId'
import selectAttributeValues from './components/selectAttributeValues'

export default {
  name: 'documentAssociationConfig',
  components: { selectStandardId, selectAttributeValues },
  data() {
    return {
      standardId: localStorage.getItem('standardId'),
      standardList: [],
      classTypeList: [],
      search: {
        name: '',
        classId: '',
      },
      classId: '',
      modelName: '',
      tableData: [],
      tableLoading: false,
      selectionList: [],
      idList: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      addVisiable: false,
      form: {
        standardId: '',
        name: '',
        documentTypeId: '',
        subjectDomainId: '',
        classId: '',
        classAttributeId: '',
      },
      rules: {
        name: [{ required: true, message: '请输入任务名称', trigger: 'blur' }],
        documentTypeId: [{ required: true, message: '请选择文档类型', trigger: 'change' }],
        classId: [{ required: true, message: '请选择实体', trigger: 'change' }],
        classAttributeId: [{ required: true, message: '请选择属性', trigger: 'change' }],
      },
      modelVisiable: false,
      documentTypeList: [],
      themeList: [],
      classList: [],
      attributeList: [],
      attributeValuesVisiable: false,
      attributeCode: '',
      formTitle: '',
    }
  },
  watch: {
    standardId(newVal) {
      if (newVal) {
        this.getClassTypeList()
        this.searchList()
      }
    },
    classId() {
      this.searchList()
    },
  },
  created() {
    this.getClassTypeList()
    this.searchList()
  },
  activated() {
    this.standardId = localStorage.getItem('standardId')
  },
  methods: {
    updateStandardId(val) {
      this.standardId = val
      this.changeStandardId()
    },
    // 获取文档类型下拉数据
    async getdocumentTypeList() {
      const parameter = {
        standardId: this.standardId,
      }
      const res = await documentConfigService.getDocumentTypeClass(parameter)
      if (res && res.code === 0 && res.data) {
        this.documentTypeList = res.data
      }
    },
    // 获取主题下拉数据
    async getThemeList() {
      const parameter = {
        standard_id: this.standardId,
        pageno: 1,
        pagesize: 999,
      }
      const res = await StdSubjectDomainService.list(parameter)
      if (res && res.code === 0 && res.data) {
        this.themeList = _.sortBy(res.data, (item) => {
          return item.seqNo
        })
      }
    },
    // 获取实体列表
    async getClassList() {
      const parameter = {
        standardId: this.form.standardId,
        subjectDomainId: this.form.subjectDomainId,
      }
      const res = await documentConfigService.getTagTypeClass(parameter)
      if (res && res.code === 0 && res.data) {
        this.classList = res.data
      }
    },
    // 获取实体列表
    async getClassTypeList() {
      const parameter = {
        standard_id: this.standardId,
        data_type: 1,
        approve_status: 1,
      }
      const res = await stdClassListService.getClassList(parameter)
      if (res && res.code === 0 && res.data) {
        this.classTypeList = res.data
      }
    },
    // 获取属性列表
    async getAttrList() {
      const res = await assetService.getClassAndClassTypeAttrDropDowData({
        classId: this.form.classId,
        skipCount: 0,
        maxResultCount: 999,
        sorting: '',
        nameOrCode: '',
      })
      if (res && res.code === 0 && res.data) {
        this.attributeList = res.data
      }
    },
    // 选择主题
    changeThemeId() {
      this.form.classId = ''
      this.form.classAttributeId = ''
      this.getClassList()
    },
    // 表格多选
    selectionChange(val) {
      this.selectionList = val
      this.idList = _.map(val, (item) => {
        return item.id
      })
    },
    sortChange() {},
    // 手动执行
    async toExecute(row) {
      row.loading = true
      const res = await documentConfigService.manualExecute({ id: row.id })
      row.loading = false
      if (res && res.code === 0) {
        this.$message.success('操作成功')
        this.searchList()
      }
    },
    // 删除
    toDelete(ids) {
      if (!ids.length) {
        this.$message.info('请选择要删除的数据')
        return
      }
      this.$confirm('确认要删除所选数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await documentConfigService.deleteDocumentParseTask(ids)
        if (res && res.code === 0) {
          this.$message.success('删除成功')
          this.searchList()
        }
      })
    },
    // 新增/编辑
    toAdd(type, row) {
      this.addVisiable = true
      if (type === 'create') {
        this.formTitle = '新增'
        this.form = this.$options.data().form
      } else if (type === 'update') {
        this.formTitle = '编辑'
        this.getDetail(row)
      }
      this.standardList = localStorage.getItem('standardList')
        ? JSON.parse(localStorage.getItem('standardList'))
        : ''
      this.form.standardId = this.standardId
      this.changeStandardId()
    },
    // 搜索
    searchList() {
      this.page.pageNo = 1
      this.getTableList()
    },
    // 获取表格数据
    async getTableList() {
      this.tableLoading = true
      const res = await documentConfigService.getDocumentParseTask({
        ...this.search,
        standardId: this.standardId,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
      })
      this.tableLoading = false
      if (res && res.code === 0 && res.data) {
        this.tableData = res.data
        this.page.total = res.totalCount
      } else {
        this.tableData = []
        this.page.total = 0
      }
    },
    handleSizeChange(pageSize) {
      this.page.pageSize = pageSize
      this.getTableList()
    },
    handleCurrentChange(pageNo) {
      this.page.pageNo = pageNo
      this.getTableList()
    },
    closeBaseFormDialog() {
      this.$refs.baseForm.resetFields()
      this.addVisiable = false
    },
    // 新增保存
    saveForm() {
      this.$refs.baseForm.validate(async (valid) => {
        if (valid) {
          if (this.form.id) {
            // 编辑
            const res = await documentConfigService.updateDocumentParseTask(this.form.id, this.form)
            if (res && res.code === 0) {
              this.$message.success('保存成功')
              this.searchList()
              this.closeBaseFormDialog()
            }
          } else {
            // 新增
            const res = await documentConfigService.addDocumentParseTask(this.form)
            if (res && res.code === 0) {
              this.$message.success('新增成功')
              this.searchList()
              this.closeBaseFormDialog()
            }
          }
        }
      })
    },
    // 获取表单详情
    async getDetail(row) {
      const res = await documentConfigService.getDocumentParseTaskById({
        id: row.id,
      })
      if (res && res.code === 0 && res.data) {
        this.form = res.data
        this.getAttrList()
      }
    },
    closeAttributeDialog() {
      this.attributeValuesVisiable = false
    },
    changeStandardId() {
      this.form.classId = ''
      this.form.classAttributeId = ''
      this.getdocumentTypeList()
      this.getThemeList()
      this.getClassList()
    },
    changeClassId() {
      this.form.classAttributeId = ''
      this.getAttrList()
    },
    updateAttributeValue() {
      // this.form.dataName = val[this.attributeCode]
    },
    changeClassAttributeId(val) {
      if (val) {
        _.map(this.attributeList, (item) => {
          if (val === item.id) {
            this.attributeCode = item.code
          }
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.can-not-input {
  ::v-deep input {
    pointer-events: none;
  }
}

</style>
